import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { createBrowserHistory } from 'history';

/**
 * Wrap for React class components
 * to pass navigate and location parameters to props
 */
export const withRouter = (Component) => {
	const Wrapper = (props) => {
		const navigate = useNavigate();
		const location = useLocation();
		const params = useParams();
		const history = React.useMemo(() => createBrowserHistory(), []);

		return <Component history={history} navigate={navigate} location={location} params={params} {...props} />;
	};

	return Wrapper;
};

export const withSearchParams = (Component) => {
	const Wrapper = (props) => {
		const [searchParams, setSearchParams] = useSearchParams();

		return <Component searchParams={searchParams} setSearchParams={setSearchParams} {...props} />;
	};

	return Wrapper;
};
